import { html, LitElement } from 'lit';
import { TagKey } from '@cof/tag-catalog-fs-lienholder-mfe';
import { style } from './lender-payoff-amount.style.js';
import { DebugService } from '@services/debug.service';
import { stratum } from '../../../constants/stratum.js';
import { LenderService } from '@services/lender.service';
import '@cof/fs-currency-field-wc-beta/fs-currency-field.js';
import '@cof/fs-text-field-wc/fs-text-field.js';
import { customElement } from 'lit/decorators.js';

@customElement('refi-lender-payoff-amount')
export class RefiLenderPayoffAmountComponent extends LitElement {
  constructor() {
    super();
    this.debug = new DebugService('RefiLenderPayoffAmount');
    this.lenderInfo = {};
    this.clickTagSent = false;
  }

  static properties = {};

  static styles = [style];

  clickTagSent: boolean;
  debug: DebugService;
  lenderInfo: any;

  connectedCallback() {
    super.connectedCallback();
    this.lenderInfo = LenderService.getLienholder();
  }

  render() {
    this.debug.log('rendered lender-payoff-amount');
    return html`
      <div class="lender__payoff_amount">
        <fs-currency-field
          id="lenderPayoffAmount"
          name="lenderPayoffAmount"
          min="1"
          max="10000000"
          decimal-separator="none"
          maximum-fraction-digits="0"
          minimum-decimal-percision="0"
          required
          readonly
          value="${this.lenderInfo.currentLoanPayOffAmount}"
          @click="${this.lenderPayoffClicked}"
          value-missing-message="Please enter a valid payoff amount"
          range-underflow-message="Amount entered should be greater than $0"
        >
          Payoff amount
        </fs-currency-field>
      </div>
    `;
  }

  lenderPayoffClicked() {
    if (!this.clickTagSent) {
      this.debug.log('Lender Payoff Clicked');
      stratum.publishTag(TagKey.LENDER_CHECKOUT_PAYOFF_AMOUNT_CLICKED);
      this.clickTagSent = true;
    }
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'refi-lender-payoff-amount': RefiLenderPayoffAmountComponent;
  }
}
